import React, { useCallback, useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import qs from "qs";
import styled from "styled-components";
import isEmpty from "lodash/isEmpty";
import each from "lodash/each";
import produce from "immer";
import DotLoader from "../Loaders/DotLoader";
import Modal from "../Modal";
import {
  loadForm3,
  runEffect3,
  unloadEffect3,
  dispatchEvent3,
  subscribe3,
  setForm3Section,
  saveForm3,
  addNote3,
  uploadv3,
  finishUpload3,
  initUpload3,
  streamUpload3,
  removeUploadv3,
  setFormStop3,
  login3,
  collect3,
  download3,
  cancelLogin,
  resetZeroId,
} from "../../actions";
import {
  getEffects,
  getUploads,
  getPubSub3,
  getEffectsLoading,
  getIsInputDisabled,
  getErrors,
  getForm3Nodes,
  getForm3Id,
  getForm3Loading,
  getForm3ActiveSection,
  getForm3Data,
  getForm3ValidationErrors,
  getForm3State,
  getForm3Closed,
  getUserPersistentProfile,
  getUser,
  getForm3Stop,
  getForm3Attachments,
  getForm3Error,
  getForm3Process,
  getLoginSession,
  getZeroIds,
  getFormDataId,
} from "../../reducers";
import IdleTimeout from "../IdleTimeout";
import FormMode from "./FormMode";
import ChatBox from "./ChatBox";
import ErrorPage from "./ErrorPage";

const RWrapper = styled.div`
  position: relative;
`;

const Form = (props) => {
  const {
    activeSection = 0,
    addNote: _addNote,
    closed,
    configuration,
    currentState,
    download,
    error,
    extra = {},
    formData,
    formDataId,
    formId,
    loadForm,
    match,
    nodes,
    queryParams = {},
    save: _save,
    setForm3Section,
    user,
    zeroIds,
  } = props;
  const { reset = null, next = null } = queryParams;
  const { oneForm } = extra;
  const { params } = match;
  const { id } = params; // <-- used if we have short URL
  const [_data, setData] = useState({});

  useEffect(() => {
    /**
     * handle reset flag
     *
     * if reset-flag is set in queryParam we will reset the form from start.
     * This is done when we initiate a new form. If not the reset flag is passed the form will continue on the activeSession and with the activeFormDataId
     */
    if (reset || id) {
      localStorage.setItem("activeSectionIndex", 0);

      if (queryParams.formDataId) {
        localStorage.setItem("activeFormDataId", queryParams.formDataId);
      }

      delete queryParams.reset;
      props.history.replace({
        search: qs.stringify(queryParams),
      });
    }

    /**
     * handle oneForm
     */
    if (oneForm && !queryParams.formDataId) {
      queryParams.formId = extra.formId;
      props.history.replace({
        search: qs.stringify(queryParams),
      });
      localStorage.setItem("activeSectionIndex", 0);
      delete queryParams.reset;

      loadForm({
        formId: extra.formId,
        activeSectionIndex: 0,
      });
    }

    /**
     * clean-up actions
     */
    return () => {
      localStorage.removeItem("activeFormDataId");
      localStorage.removeItem("activeSectionIndex");

      /**
       * NOTE NOTE NOTE:
       *
       * We did have the below code here because redirects from form with oneForm-attributes
       * did not work properly when existing forms. (The formDataId-was in the URL).
       * Anyway, this caused the submit to break and formDataId-links to be prepended with
       * %3F .
       *
       * IF you are about to change this and manipulate the url ENSURE that you can submit
       * a form: BOTH from oneForm and wihtout and make SURE that the URL does not contain any %3F
       * or any other strange chars that will break!
       */
      // if (oneForm) {

      // 2022-10-31: SEE NOTE ABOVE!
      // DO NOT REMOVE COMMENTED CODE BELOW THIS.
      //
      // const _queryParams = qs.parse(window.location.search)

      // delete _queryParams.formDataId;
      // delete _queryParams.formId;

      // console.log('_queryParams',_queryParams)

      // props.history.replace({
      //   search: qs.stringify(_queryParams)
      // });
      // 2022-10-31: END OF NODE!
      // }
    };

    /**
     * NOTE ON DEP ARRAY
     *
     * We included the values in the comments below first. But we had isseus with to many reducer calls, so we dropped this and replaced with an empty dep array
     * IF you include values in the dep array, ensure that you can do the following:
     *
     * 1. Enter a form
     * 2. Add anything to the form
     * 3. Cancel/Quit the form (DO NOT HARD RELOAD)
     * 4. Enter the same form again. There should not be any old values left
     *
     */
    //eslint-disable-next-line
  }, []); // [qsFormId, qpFormDataId, oneForm, oneFormId])

  useEffect(() => {
    const formDataId = queryParams.formDataId
      ? queryParams.formDataId
      : props.formData && props.formData._id;

    if (!isEmpty(zeroIds)) {
      props.resetZeroId({ ids: zeroIds });
      each(zeroIds, (value, key) => {
        _save({ key, value: null, id: formDataId });
      });
    }
  }, [zeroIds]);

  /**
   * handle next, i.e. remove it from queryParmams and increate activeSection
   */
  useEffect(() => {
    if (next && nodes) {
      delete queryParams.next;
      props.history.replace({
        search: qs.stringify(queryParams),
      });

      const rootNode = nodes[formId];
      let targetIndex = +activeSection + +next;

      if (rootNode?.structure) {
        while (targetIndex < rootNode.structure.length) {
          const sectionNode = nodes[rootNode.structure[targetIndex]];
          if (!sectionNode || !sectionNode.hideComponent) {
            break;
          }
          targetIndex++;
        }
      }

      setForm3Section({ index: targetIndex });
    }
  }, [activeSection, next]);

  useEffect(() => {
    if (formDataId) {
      queryParams.formDataId = formDataId;
      props.history.replace({
        search: qs.stringify(queryParams),
      });
    }
  }, [formDataId]);

  /**
   * ensure that we have *formDataId* in queryParam
   */

  useEffect(() => {
    setData(formData);
    if (!queryParams.formDataId) {
      queryParams.formDataId = formData._id;
      localStorage.setItem("activeFormDataId", formData._id);
    }

    if (!queryParams.formId) {
      queryParams.formId = formId;
    }

    props.history.replace({
      search: qs.stringify(queryParams),
    });
  }, [formData, formId]);

  const save = useCallback(
    ({ key, value, context }) => {
      setData(
        produce((draft) => {
          draft[key] = value;
          /**
           * pushTo support
           *
           * i.e. if value can be pushed/saved to other components
           *
           */
          const node = nodes[key];

          /**
           * If we do not find any nodes it does not mean there is an issue
           * This can be the casue of saving to a name instead of key (like geoLocationCoords)
           * It can also indicate problems with the form. If we have !node we will just return
           * and not continue with the push feature
           */
          if (!node) {
            return;
          }
        })
      );

      _save({ key, value, id: formDataId, context });
    },
    [_save, formDataId]
  );

  const addNote = useCallback(
    ({ note }) => {
      const _formDataId =
        localStorage.getItem("activeFormDataId") || formDataId;
      _addNote({ note, formDataId: _formDataId });
    },
    [_addNote, formDataId]
  );

  const subscribe = useCallback(() => {}, []);

  if (closed) {
    return (
      <div>
        This ticket is closed. You should consider redirecting users here
      </div>
    );
  }

  if (error) {
    return <Modal heading="Error" text={error} homeButton={true} />;
  }

  if (!nodes) {
    return <DotLoader />;
  }

  if (!formId) {
    return null;
  }

  const formNode = nodes[formId];

  if (!formNode) {
    return null;
  }

  const findActivtSection = (activeSection) => {
    let numOfSection = formNode.structure.length;

    for (let i = activeSection; i < numOfSection; i++) {
      let rootNode = nodes[formNode.structure[i]];
      if (!rootNode.hideComponent) {
        return rootNode;
      }
    }
    return null;
  };

  let rootNode = findActivtSection(activeSection);

  if (!rootNode) {
    return <ErrorPage />;
  }

  if (!currentState) {
    return <div>NO CURRENT STATE</div>;
  }

  const { subType = "edit", features = [] } = currentState;

  const FormComponent = FormMode[subType]
    ? FormMode[subType]
    : FormMode["edit"];

  const { notes = {} } = formData;
  const { external = [] } = notes;

  if (props.formLoading) {
    return null;
  }

  return (
    <RWrapper>
      {!user && (
        <IdleTimeout
          idleWarning={configuration.idleWarning}
          idleLogout={configuration.idleLogout}
          warningText="Idle.anonymousWarning"
          confirmLabel="Idle.anonymousWarningConfirm"
          closeLabel="Idle.anonymousWarningClose"
          redirectTo="home"
        />
      )}
      <FormComponent
        {...props}
        save={save}
        rootNode={rootNode}
        subscribe={subscribe}
        addNote={addNote}
        download={download}
      />
      {features.includes("chat") && (
        <ChatBox notes={external} addNote={addNote} formDataId={formData._id} />
      )}
    </RWrapper>
  );
};

const mapStateToProps = (state) => ({
  pubSub: getPubSub3(state),
  effects: getEffects(state),
  effectsLoading: getEffectsLoading(state),
  isInputDisabled: getIsInputDisabled(state),
  errors: getErrors(state),
  formLoading: getForm3Loading(state),
  nodes: getForm3Nodes(state),
  formId: getForm3Id(state),
  activeSection: getForm3ActiveSection(state),
  formData: getForm3Data(state),
  validationErrors: getForm3ValidationErrors(state),
  currentState: getForm3State(state),
  closed: getForm3Closed(state),
  uploads: getUploads(state),
  userPersistentProfile: getUserPersistentProfile(state),
  user: getUser(state),
  stop: getForm3Stop(state),
  attachments: getForm3Attachments(state),
  error: getForm3Error(state),
  formProcess: getForm3Process(state),
  loginSession: getLoginSession(state),
  zeroIds: getZeroIds(state),
  formDataId: getFormDataId(state),
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    runEffect: ({
      source,
      effectId,
      componentId,
      pageId,
      context,
      pageType,
    }) => {
      dispatch(
        runEffect3({
          source,
          effectId,
          componentId,
          pageId,
          pageType: pageType ? pageType : "form",
          context,
          clientStatus: ownProps?.formData?.status,
        })
      );
    },
    loadForm: ({ formId, formDataId, activeSectionIndex }) => {
      dispatch(loadForm3({ formId, formDataId, activeSectionIndex }));
    },
    dispatchEvent: ({
      pageType,
      pageId,
      nodeId,
      event,
      context,
      clientStatus,
    }) => {
      dispatch(
        dispatchEvent3({
          pageType,
          pageId,
          nodeId,
          event,
          context,
          clientStatus: clientStatus || ownProps?.formData?.status,
        })
      );
    },
    subscribe: ({ channel }) => {
      dispatch(subscribe3({ channel }));
    },
    setForm3Section: ({ index }) => {
      dispatch(setForm3Section({ index }));
    },
    save: ({ key, value, data, id, context }) => {
      dispatch(
        saveForm3({
          key,
          value,
          data,
          id,
          context,
          clientStatus: ownProps?.formData?.status,
        })
      );
    },
    addNote: ({ noteType = "external", note, formDataId }) => {
      const noteId = uuidv4();
      dispatch(addNote3({ noteType, note, formDataId, noteId }));
    },
    upload: ({
      name,
      data,
      mimeType,
      assetId,
      size,
      formDataId,
      componentId,
      uploadName,
    }) => {
      dispatch(
        uploadv3({
          name,
          data,
          mimeType,
          assetId,
          formDataId,
          componentId,
          page: ownProps.page,
          _id: ownProps.rowId,
          size,
          uploadName,
        })
      );
    },
    initUpload: ({
      assetId,
      name,
      size,
      estimatedChunks,
      originalName,
      mimeType,
      formDataId,
    }) => {
      dispatch(
        initUpload3({
          assetId,
          name,
          size,
          originalName,
          estimatedChunks,
          mimeType,
          formDataId,
        })
      );
    },
    streamUpload: ({ assetId, data, chunkId }) => {
      dispatch(streamUpload3({ assetId, data, chunkId }));
    },
    finishUpload: ({ assetId }) => {
      dispatch(finishUpload3({ assetId }));
    },
    removeUpload: ({ assetId }) => {
      dispatch(removeUploadv3({ assetId }));
    },
    //eslint-disable-next-line
    // unloadForm3: ({ formDataId }) => {
    //   dispatch(unloadForm3({ formDataId }));
    // },
    setStop: (stop) => {
      dispatch(setFormStop3({ stop }));
    },
    login: ({ strategy = "local", props }) => {
      dispatch(login3({ strategy, props, source: "form" }));
    },
    collect: ({ strategy = "local", props, session }) => {
      dispatch(collect3({ strategy, props, session, source: "form" }));
    },
    download: ({ id, page, pageId, onlyURL = true, preview }) => {
      dispatch(download3({ id, page, pageId, onlyURL, preview }));
    },
    cancelLogin: ({ strategy, session }) => {
      dispatch(cancelLogin({ strategy, session }));
    },
    resetZeroId: ({ ids }) => {
      dispatch(resetZeroId({ ids }));
    },
    unloadEffect: ({ effectId }) => {
      dispatch(unloadEffect3({ effectId }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Form));
